import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import { ThemeProvider } from 'styled-components';
import { Grid } from '@atlaskit/page';
import ProgressTrackerLink from '../ProgressTrackerLink';
import ProgressTrackerStage from '../ProgressTrackerStage';
import { ProgressTrackerContainer } from './styled';
var TRANSITION_SPEED = 300;
var LINEAR_TRANSITION_SPEED = 50;
var easeOut = 'cubic-bezier(0.15,1,0.3,1)';

var ProgressTracker = /*#__PURE__*/function (_PureComponent) {
  _inherits(ProgressTracker, _PureComponent);

  var _super = _createSuper(ProgressTracker);

  function ProgressTracker() {
    var _this;

    _classCallCheck(this, ProgressTracker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "createTheme", function () {
      return {
        spacing: _this.props.spacing,
        columns: _this.props.items.length * 2
      };
    });

    _defineProperty(_assertThisInitialized(_this), "state", {
      prevStages: _this.props.items.map(function (stage, index) {
        return _objectSpread(_objectSpread({}, stage), {}, {
          percentageComplete: 0
        });
      })
    });

    return _this;
  }

  _createClass(ProgressTracker, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var prevStages = nextProps.items.map(function (stage) {
        var oldStage = _this2.props.items.find(function (st) {
          return st.id === stage.id;
        });

        return oldStage !== undefined ? oldStage : stage;
      });
      this.setState({
        prevStages: prevStages
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var testId = this.props.testId;
      var progressChanges = this.props.items.filter(function (stage, index) {
        return stage.percentageComplete !== _this3.state.prevStages[index].percentageComplete;
      }).length;
      var totalStepsForward = this.props.items.filter(function (stage, index) {
        return stage.percentageComplete > _this3.state.prevStages[index].percentageComplete;
      }).length;
      var totalStepsBack = this.props.items.filter(function (stage, index) {
        return stage.percentageComplete < _this3.state.prevStages[index].percentageComplete;
      }).length;
      var stepsForward = totalStepsForward;
      var stepsBack = totalStepsBack;
      var items = this.props.items.map(function (stage, index) {
        var transitionSpeed = 0;
        var transitionDelay = 0;
        var transitionEasing = progressChanges > 1 ? 'linear' : easeOut;

        if (_this3.props.animated) {
          transitionSpeed = progressChanges > 1 ? LINEAR_TRANSITION_SPEED : TRANSITION_SPEED;

          if (stage.percentageComplete < _this3.state.prevStages[index].percentageComplete) {
            /** load each transition sequentially in reverse */
            transitionDelay = (stepsBack - 1) * transitionSpeed;
            stepsBack -= 1;
          } else if (stage.percentageComplete > _this3.state.prevStages[index].percentageComplete) {
            /** load each transition sequentially */
            transitionDelay = (totalStepsForward - stepsForward) * transitionSpeed;
            stepsForward -= 1;
          }
        }

        return /*#__PURE__*/React.createElement(ProgressTrackerStage, {
          key: stage.id,
          item: stage,
          render: _this3.props.render,
          transitionSpeed: transitionSpeed,
          transitionDelay: transitionDelay,
          transitionEasing: transitionEasing
        });
      });
      return /*#__PURE__*/React.createElement(ThemeProvider, {
        theme: this.createTheme()
      }, /*#__PURE__*/React.createElement(Grid, {
        testId: testId
      }, /*#__PURE__*/React.createElement(ProgressTrackerContainer, null, items)));
    }
  }]);

  return ProgressTracker;
}(PureComponent);

_defineProperty(ProgressTracker, "defaultProps", {
  items: [],
  spacing: 'cosy',
  render: {
    link: function link(props) {
      return /*#__PURE__*/React.createElement(ProgressTrackerLink, props);
    }
  },
  animated: true
});

export { ProgressTracker as default };